import { Suspense } from 'react';

import { lazyWithRetry as lazy } from 'src/utils/lazy-with-retry';
import { Outlet } from 'react-router-dom';
// layouts
import AuthModernCompactLayout from 'src/layouts/auth/modern-compact';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const LoginModernPage = lazy(() => import('src/pages/auth-demo/modern/login'));
const RegisterModernPage = lazy(() => import('src/pages/auth-demo/modern/register'));
const VerifyModernPage = lazy(() => import('src/pages/auth-demo/modern/verify'));

// ----------------------------------------------------------------------

const authModern = {
  path: '',
  element: (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: 'login',
      element: (
        <AuthModernCompactLayout>
          <Outlet />
        </AuthModernCompactLayout>
      ),
      children: [
        { path: '', element: <LoginModernPage /> },
      ],
    },
    {
      path: 'register',
      element: (
        <AuthModernCompactLayout>
          <Outlet />
        </AuthModernCompactLayout>
      ),
      children: [
        { path: '', element: <RegisterModernPage /> },
      ]
    },
    {
      path: 'verify',
      element: (
        <AuthModernCompactLayout>
          <Outlet />
        </AuthModernCompactLayout>
      ),
      children: [
        { path: '', element: <VerifyModernPage /> },
      ],
    },
  ],
};

export const authDemoRoutes = [
  {
    path: 'auth',
    children: [authModern],
  },
];
